import { motion } from "framer-motion";

export function LogoIntro() {
  return (
    <motion.div
      aria-hidden="true"
      className="pointer-events-none fixed inset-x-0 top-0 z-40 h-1 bg-gradient-to-r from-cyan-300 via-teal-300 to-white"
      initial={{ scaleX: 0, opacity: 1 }}
      animate={{ scaleX: 1, opacity: 0 }}
      transition={{ duration: 1.2, ease: "easeOut" }}
      style={{ transformOrigin: "left" }}
    />
  );
}
